import { render } from "./SensorLogsExport.vue?vue&type=template&id=2fd74d0f&scoped=true&ts=true"
import script from "./SensorLogsExport.vue?vue&type=script&lang=ts"
export * from "./SensorLogsExport.vue?vue&type=script&lang=ts"

import "./SensorLogsExport.vue?vue&type=style&index=0&id=2fd74d0f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd74d0f"]])

export default __exports__